/**
 * LandingStep 도메인 상수.
 */

/**
 * Landing 시안 전용 색 팔레트.
 *
 * Figma 상세페이지 시안이 앱 기존 COLORS와 다른 팔레트(brand #FF7037,
 * negative #EF4444, positive #22C55E 등)를 쓴다. 2026-05-20 사용자 결정으로
 * Landing 화면은 시안값을 단일 출처로 따른다. (기존 화면 OrderStep 등은 COLORS 유지)
 */
export const LANDING_COLORS = {
  brand: '#FF7037',
  bg: '#F6F6F6',
  negative: '#EF4444',
  positive: '#22C55E',
  consCardBg: '#FFF7F7',
  consCardBorder: '#FF7F7F',
  prosCardBg: '#FBFFFD',
  prosCardBorder: '#4ADE80',
} as const
